import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'entrega',
    [ORDER_METHODS.PICKUP]: 'recogida',
    [ORDER_METHODS.ROOM_SERVICE]: 'en local',
  },
  feedback: {
    payment_method_disabled: 'No aceptamos pagos con {{paymentMethod}} para pedidos de {{orderMethod}}',
    cash_disabled: 'No aceptamos pagos en efectivo para pedidos de {{orderMethod}}',
  },
};
